/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";

import { useAppState } from "hooks/AppContext";
import { ArticleHeader } from "./ArticleHeader";
import { LeadMediaModule } from "./LeadMediaModule";
import { ArticleSocial } from "./ArticleSocial";
import { ArticleContent } from "./ArticleContent";
import { SponsorModule } from "./SponsorModule";
import { RecentArticles } from "./RecentArticles";
import { NewsletterCard } from "./Newsletter";

import styles from "./articleContainer.module.scss";

export const ArticleContainer = () => {
    const { article } = useAppState();
    const {
        articleContentModules,
        articleUri,
        blockHeadingPrefix,
        breadcrumbLinks,
        contentAuthor,
        leadMedia,
        listBuilder,
        listicleContentType,
        postListBodyContent,
        product,
        slug,
        sponsor,
        tags,
        templateName,
        title,
        componentProps,
        dateUpdated,
        postDate,
        primaryTopic
    } = article;

    const social = {
        articleUri,
        slug,
        title,
        writerName: contentAuthor?.writerName,
        writerSlug: contentAuthor?.writerSlug,
        twitterHandle: contentAuthor?.twitterHandle,
        dateUpdated: dateUpdated ?? postDate
    };

    const author = {
        articleUri,
        slug,
        title,
        ...contentAuthor
    };

    const sponsorModuleProps = {
        listicleContentType,
        tags,
        product,
        ...sponsor,
        componentProps
    };

    const articleContentProps = {
        articleContentModules,
        postListBodyContent,
        blockHeadingPrefix,
        listBuilder,
        templateName,
        sponsorModuleProps: { ...sponsorModuleProps },
        author,
        dateUpdated,
        postDate
    };

    const [newsletterCardViewed, setNewsletterCardViewed] = React.useState(false);

    return (
        <article className={styles.article}>
            <div className={styles.articleContainer}>
                <ArticleHeader articleTitle={title} breadcrumbs={breadcrumbLinks} />
                <div className={styles.articleBannerFlexContainer}>
                    <div className={styles.articleBody}>
                        <ArticleSocial {...social} />
                        <div className={styles.articleBodyWrapper}>
                            <div className={styles.articleContentWrapper}>
                                {leadMedia && (
                                    <LeadMediaModule {...leadMedia} showPinterest={true} />
                                )}
                                <ArticleContent {...articleContentProps} />
                                <SponsorModule {...{ sponsorType: "midway", ...sponsorModuleProps }} />
                                <aside className={styles.articleContentNewsletterWrapper}>
                                    <NewsletterCard formViewed={newsletterCardViewed} changeToFormViewed={() => setNewsletterCardViewed(true)} />
                                </aside>
                                <RecentArticles primaryTopic={primaryTopic} />
                            </div>
                            <div className={styles.rightRailWrapper}>
                                <div className={styles.rightRail}>
                                    <SponsorModule {...{ sponsorType: "sidebar", ...sponsorModuleProps }} />
                                    <aside className={styles.rightRailNewsletterWrapper}>
                                        <NewsletterCard formViewed={newsletterCardViewed} changeToFormViewed={() => setNewsletterCardViewed(true)} />
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    );
};
